import React, {useState} from "react"
import './ContactUs.css'
import { useAuth0 } from "@auth0/auth0-react";

const ContactUs = () => {
    const { loginWithRedirect, isAuthenticated } = useAuth0();
    const [users, setUser] = useState(
        {
           Name: '', Email: '',Message: ''
        }
    )

    let name, value
    const data = (e) =>{
        name = e.target.name;
        value = e.target.value;
        setUser({...users, [name]:value})
    }
    const senddata = async (e) =>{
        const{ Name, Email, Message} = users
        e.preventDefault();
        const options = {
            method: 'POST',
            headers: {
                'Content-Type' : 'application/json'
            },
            body: JSON.stringify(
                {
                    Name, Email, Message
                }
            )
        }
        const res = await fetch('', options)
        console.log(res)
        if(res){
            alert("Message sent")
        }
        else{
            alert("Error occured")
        }

    }
  return (
    <div className='contact_container' >

        <div className='form'>
              
              <div className='formage'>
                      
                    <form>
                         <h2>Contact Us</h2>
                         <p>We're here to help!Send us your query via the form below or send us an email at helpdesk@gmail.com </p>
                         <div class="form-group">
                             <label htmlFor="name">Name:</label>
                             <input type="text" name="Name" value= {users.Name} required  onChange={data}/>
                        </div>
                         <div class="form-group">
                             <label htmlFor="email">Email Adress:</label>
                             <input type="text" name="Email" value= {users.Email} required onChange={data} />
                         </div>
                         <div class="form-group">
                             <label htmlFor="message">Message:</label>
                             <textarea name="Message" value= {users.Message} id="message" cols="10" rows="4" onChange={data}></textarea>
                         </div>
                         {
                            isAuthenticated?
                              <button type='submit' onClick={senddata}>Submit</button>
                            : <button type='submit' onClick={() =>loginWithRedirect()}>Login</button>
                         }
                        
                    </form>
                    <div className='img'>
                         <img src="./img/contact.jpg" alt="contact"  />
                     </div>
                </div>
              
            </div>
            
           
        </div>

   
  )
}

export default ContactUs